import { Component } from '@angular/core';
import { ApiUrlHelper } from '../../../../common/api-url-helper';
import { CommonService } from '../../../../services/common/common.service';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { StateService } from '../../../../services/common/claim-year.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { SubContractorUnconnectedProject, commonLabelConstants } from '../../../../constants/label-constants';
import { environment } from '../../../../../environments/environment';
import { CustomCurrencyPipe } from '../../../../common/pipes/custom-currency.pipe';
import { SharedService } from '../../../../services/shared-service/shared.service';
import { Subject, takeUntil } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { ValidationService } from '../../../../services/common/validation-service';

@Component({
  selector: 'app-sub-contractor-form',
  templateUrl: './sub-contractor-unconnected-form.component.html',
  styleUrl: './sub-contractor-unconnected-form.component.scss'
})

export class SubContractorFormComponent {

  env: any = environment;
  projectList: any = [];
  companyId: any = 0
  claimYearId: any = 0;
  subContractorUnconnectedRNDForm!: FormGroup;
  onDestroy$: Subject<void> = new Subject();
  detail: any = []
  isLoading: boolean = false;
  labelConstants = SubContractorUnconnectedProject;
  commonLabelConstants = commonLabelConstants;
  isLocked: boolean = false;

  constructor(
    private readonly api: ApiUrlHelper,
    private readonly commonService: CommonService,
    private readonly sharedDataService: StateService,
    private readonly spinner: NgxSpinnerService,
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly sharedService: SharedService,
    private readonly currencyPipe: CustomCurrencyPipe,
    private readonly validationService:ValidationService) {
  }

  get subContractor(): FormArray {
    return this.subContractorUnconnectedRNDForm.get('subContractor') as FormArray
  }

  ngOnInit() {
    this.subContractorUnconnectedRNDForm = this.fb.group({
      subContractor: this.fb.array([])
    });
    this.sharedDataService.companyId$.subscribe((companyId) => {
      this.companyId = companyId;
    });
    this.sharedDataService.yearId$.pipe(takeUntil(this.onDestroy$)).subscribe((yearId) => {
      this.claimYearId = yearId ?? null;

      if (this.companyId && this.claimYearId) {
        this.resetForm();
        this.getProjectListCompanyWise(this.companyId, this.claimYearId)
      }
    });
  }

  resetForm() {
    this.subContractorUnconnectedRNDForm = this.fb.group({
      subContractor: this.fb.array([])
    });
  }

  getProjectListCompanyWise(companyId: any, claimYearId: any) {
    this.spinner.show();
    let api = this.api.apiUrl.Project.GetProjectListWithOutPagination.replace('{companyId}', companyId).replace('{claimYearId}', claimYearId);
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.projectList = response.data;
        }
        else {
          this.projectList = [];
        }
        this.getContractorDetail();
      },
      error: (error: any) => {
        console.log(error);
        this.spinner.hide();
      }
    });
  }

  createContractor(): FormGroup {
    return this.fb.group({
      subContractorUnConnectedId: [null],
      subContractorUnConnectedResourceId: [null],
      subContractorName: [{ value: '', disabled: true }],
      descriptionOfActivities: [''],
      projects: this.fb.array([]),
      costUK: [{ value: '', disabled: true }],
      costNonUK: [{ value: '', disabled: true }],
      totalEligibilityAmountForUK: [{ value: 0, disabled: true }],
      totalEligibilityAmountForNonUK: [{ value: 0, disabled: true }],
    });
  }

  createContractorProjectDetail() {
    return this.fb.group({
      subContractorUnConnectedEligibilityId: [null],
      subContractorUnConnectedResourceId: [null],
      projectId: [''],
      rndEligibility: [''],
    });
  }

  getItemAtIndex(index: number): FormGroup {
    return this.subContractor.at(index) as FormGroup;
  }

  getProjectDetails(index: any) {
    return this.getItemAtIndex(index).get('projects') as FormArray;
  }

  getContractorDetail() {
    this.isLoading = true;
    let obj = {
      companyId: this.companyId,
      claimYearId: this.claimYearId
    }
    let api = this.api.apiUrl.SubcontractorUnconnectedCostResource.GetSubcontractorUnconnectedCostResource;
    this.commonService.doPost(api, obj).pipe().subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.success) {
          this.detail = response.data;
          this.isLocked = ( this.detail[0]?.isLocked ?? false);
          this.detail.forEach((item: any) => {
            const newContractor = this.createContractor();
            newContractor.patchValue({
              subContractorUnConnectedId: item.subContractorUnConnectedId,
              subContractorName: item.subContractorName,
              subContractorUnConnectedResourceId: item.subContractorUnConnectedResourceId,
              descriptionOfActivities: item.descriptionOfActivities,
              costUK: item.costUK,
              costNonUK: item.costNonUK,
              totalEligibilityAmountForUK: item.totalEligibilityAmountForUK,
              totalEligibilityAmountForNonUK: item.totalEligibilityAmountForNonUK,
            });
            const subContractorDetailsArray = newContractor.get('projects') as FormArray;

            this.projectList.forEach((itemDetail: any) => {
              const newProjectDetail = this.createContractorProjectDetail();

              const projectData = item.projects.find(
                (projectDetail: any) =>
                  projectDetail.projectId == itemDetail.projectId
              );

              const rndEligibilityValue =
                projectData?.rndEligibility
                  ? projectData.rndEligibility
                  : '0';
              newProjectDetail.patchValue({
                subContractorUnConnectedEligibilityId: projectData
                  ? projectData.staffCostResourceEligibilityId
                  : 0,
                subContractorUnConnectedResourceId: projectData
                  ? projectData.staffCostResourceId
                  : 0,
                projectId: itemDetail.projectId,
                rndEligibility: rndEligibilityValue,
              });
              newProjectDetail.disable();
              subContractorDetailsArray.push(newProjectDetail);
            });
            this.subContractor.push(newContractor);
          })
          this.spinner.hide();
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        console.log(error);
        this.spinner.hide();
      }
    });
  }

  getCostTotal(): number {
    return this.subContractor.controls.reduce((totalCost, contractor) => {
      const cost = contractor.get('costUK')?.value || 0;
      return totalCost + Number(cost);
    }, 0);
  }

  getCostTotal1(): number {
    return this.subContractor.controls.reduce((totalCost, contractor) => {
      const cost = contractor.get('costNonUK')?.value || 0;
      return totalCost + Number(cost);
    }, 0);
  }

  getTotalProduct(projectIndex: number): string | null {
    let totalProduct = 0;

    for (let i = 0; i < this.subContractor.length; i++) {
      const employee = this.getItemAtIndex(i);
      const projectDetails = this.getProjectDetails(i);

      if (projectIndex < projectDetails.length) {
        const totalGrossStr = employee.get('costUK')?.value;
        const totalGrossStrNonUK = employee.get('costNonUK')?.value;
        const costUK = parseFloat(totalGrossStr) || 0;
        const costNonUK = parseFloat(totalGrossStrNonUK) || 0;

        const rndEligibilityValueStr = projectDetails.at(projectIndex).get('rndEligibility')?.value;
        const rndEligibility = (parseFloat(rndEligibilityValueStr) || 0) / 100;

        totalProduct += (costUK + costNonUK) * rndEligibility;
      } else {
        console.warn(`Project index ${projectIndex} is out of bounds for employee ${i}.`);
      }
    }
    return this.currencyPipe.transform(totalProduct === 0 ? 0 : Number((totalProduct * 0.65).toFixed(2)) , environment.CurrencyFormat);
  }

  getTotalQualifyingCosts(): number {
    let total = 0;
    const employeeArray = this.subContractorUnconnectedRNDForm.get('subContractor') as FormArray;

    employeeArray.controls.forEach((employee) => {
      total += employee.get('totalEligibilityAmountForUK')?.value || 0;
    });
    return total;
  }

  getTotalQualifyingCosts1(): number {
    let total = 0;
    const employeeArray = this.subContractorUnconnectedRNDForm.get('subContractor') as FormArray;

    employeeArray.controls.forEach((employee) => {
      total += employee.get('totalEligibilityAmountForNonUK')?.value || 0;
    });
    return total;
  }

  goBack(): void {
    this.router.navigateByUrl('/dashboard');
  }
  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  exportList(): void {
    const isValid = this.validationService.validateCompanyAndYear(
      this.companyId,
      this.claimYearId
    );
    if (!isValid) {
      return;
    }
    const companyIdStr = this.companyId !== null ? String(this.companyId) : '';
    const yearIdStr = this.claimYearId !== null ? String(this.claimYearId) : '';
    let obj = {
      CompanyId: companyIdStr,
      ClaimYearId: yearIdStr,
    };
    let api = this.api.apiUrl.SubcontractorUnconnectedCostResource.ExportSubcontractorUnconnectedCostCategory;
    this.commonService.doDownloadPost(api, obj).subscribe(
      (response: HttpResponse<Blob>) => {
        const blob = response.body as Blob;
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = "Contracted Out R&D - Unconnected - Qualifying Expenditure by Cost Category.xlsx";

        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }


}
